import React, { FC, useMemo } from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import * as anchor from "@project-serum/anchor";
import Divider from '@mui/material/Divider';
import { Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';

//
const MyCustomBox = styled(Box)(({ theme }) => ({
    marginTop: "80px",
    minHeight: "1200px",
    [theme.breakpoints.down('sm')]: {
        p: {
            fontSize: "15px" // For small screens!
        },
        padding: "0 10px 0 10px",
        //marginLeft: "40px"
    },
    padding: "0 30px 0 30px",
    textAlign: 'center',
    paddingTop: "0px",
    paddingBottom: "0px",
    color: "black"
}));

//
const Content = (props: any) => {
    return (
        <MyCustomBox>
            {props.children}
        </MyCustomBox>
    );
}

export default Content;